import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {OrgAppraisalPeriod, OrgAppraisalCategory, OrgAppraisalRating, EmployeeAppraisal, QueryResult} from '@app/shared';
import { OrgSalaryMatrix } from './appraisal-admin';

@Injectable()
export class AppraisalAdminDataService {

  constructor (private http: HttpClient) { }

  getAppraisalPeriods(): Observable<any> {
    return this.http.get('/hr/appraisal-periods/search?start=0&count=-1');
  }

  getAppraisalPeriodById(id: number): Observable<any> {
    return this.http.get(`/hr/appraisal-periods/${id}`);
  }

  getAppraisalPeriodsNewPayload(): Observable<any> {
    return this.http.get('/hr/appraisal-periods/new-payload');
  }

  sendOverdueNotice(id: number): Observable<any> {
    return this.http.post(`/hr/appraisal-periods/${id}/notifications`, '');
  }

  saveOrUpdatePeriod(appraisalPeriod: OrgAppraisalPeriod): Observable<any> {
    return this.http.post('/hr/appraisal-periods', appraisalPeriod);
  }

  deletePeriod(periodId: number): Observable<any> {
    return this.http.delete(`/hr/appraisal-periods/${periodId}`);
  }

  openOrCloseAppraisalPeriod(periodId: number, open: boolean): Observable<any> {
    const url = `/hr/appraisal-periods/${periodId}/open-or-close?open=${open}`;
    return this.http.post(url, null);
  }

  getPositionGrades(): Observable<QueryResult> {
    return this.http.get<QueryResult>('/hr/lookup/position-grades');
  }

  getPositionGradesForPeriodAndRating(gradeId: number, ratingId: number): Observable<any> {
    return this.http.get(`/hr/org-salary-matrices/search?positionGrade.id=${gradeId}&appraisalRating.id=${ratingId}`);
  }

  getCategoryById(id: number): Observable<any> {
    return this.http.get(`/hr/appraisal-categories/${id}`);
  }

  getCategoryNewPayload(): Observable<any> {
    return this.http.get(`/hr/appraisal-categories/new-payload`);
  }

  getCategoryByPeriod(id: number): Observable<any> {
    return this.http.get(`/hr/appraisal-categories/search?appraisalPeriod.id=${id}&start=0&count=-1`);
  }

  getAppraisalCategoryByEmployeeClass(id: number, classId: number): Observable<QueryResult> {
    return this.http.get<QueryResult>(`/hr/appraisal-categories/search?appraisalPeriod.id=${id}&employeeClass.id=${classId}`);
  }

  saveOrUpdateCategory(category: OrgAppraisalCategory): Observable<any> {
    return this.http.post('/hr/appraisal-categories', category);
  }

  deleteAppraisalCategory(categoryId: number): Observable<any> {
    return this.http.delete(`/hr/appraisal-categories/${categoryId}`);
  }

  getRatingByPeriod(id: number): Observable<any> {
    return this.http.get(`/hr/appraisal-ratings/search?appraisalPeriod.id=${id}`);
  }

  getRatingById(id: number): Observable<any> {
    return this.http.get(`/hr/appraisal-ratings/${id}`);
  }

  getRatingNewPayload(): Observable<any> {
    return this.http.get(`/hr/appraisal-ratings/new-payload`);
  }

  saveOrUpdateRating(rating: OrgAppraisalRating): Observable<any> {
    return this.http.post('/hr/appraisal-ratings', rating);
  }

  deleteAppraisalRating(ratingId: number): Observable<any> {
    return this.http.delete(`/hr/appraisal-ratings/${ratingId}`);
  }

  getSalaryMatricesByRating(ratingId: number, appraisalPeriodId: number): Observable<any> {
    return this.http.get(`/hr/org-salary-matrices/search?appraisalRating.id=${ratingId}&appraisalPeriod.id=${appraisalPeriodId}`);
  }

  getSalaryMatricesByPeriod(appraisalPeriodId: number): Observable<any> {
    return this.http.get(`/hr/org-salary-matrices/search?appraisalPeriod.id=${appraisalPeriodId}`);
  }

  getSalaryMatricesById(id: number): Observable<any> {
    return this.http.get(`/hr/org-salary-matrices/${id}`);
  }

  getSalaryMatricesNewPayload(): Observable<any> {
    return this.http.get(`/hr/org-salary-matrices/new-payload`);
  }

  saveOrUpdateSalMatrix(salMatrix: OrgSalaryMatrix): Observable<any> {
    return this.http.post('/hr/org-salary-matrices', salMatrix);
  }

  deleteSalaryMatrix(salMatrixId: number): Observable<any> {
    return this.http.delete(`/hr/org-salary-matrices/${salMatrixId}`);
  }

  getFinancialYear(): Observable<any> {
    return this.http.get('/utils/org-years');
  }
}
